import { _get, _post } from "./Axios";

export default class AssignmentKpiApi {
  static getList(payload) {
    let params = [];

    Object.keys(payload).forEach((item) => {
      params.push(item + "=" + payload[item]);
    });

    params = params.join("&");

    return _get("kpi/asignment?"+ params);
  }

  static getDetail(payload) {
    let params = [];
    Object.keys(payload).forEach((item) => {
      params.push(item + "=" + payload[item]);
    });
    params = params.join("&");

    return _get("kpi/asignment/detail?"+ params);
  }

  static getKpiPerUnit(payload) {
    let params = [];

    Object.keys(payload).forEach((item) => {
      params.push(item + "=" + payload[item]);
    });

    params = params.join("&");

    return _get("kpi/unitkerja/?"+ params);
  }

  static create(payload) {
    return _post("kpi/aspekpenilaian/assignment", payload);
  }

  static delete(payload) {
    return _post("kpi/asignment/delete", payload);
  }
}
